import { render, staticRenderFns } from "./DamagedDetails.vue?vue&type=template&id=5efa45c8&scoped=true&"
import script from "./DamagedDetails.vue?vue&type=script&lang=js&"
export * from "./DamagedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa45c8",
  null
  
)

export default component.exports